import {
  missingClientsImage,
  missingPayablesImage,
  missingReceivablesImage,
} from '../../../assets';
import { Language } from '../../../configs/language';
import leng from '../../../constants/leng';

export type EmptyStatePage = 'clients' | 'receivables' | 'payables';
interface EmptyStateConfig {
  boxTitle: string;
  image: string;
  messageTitle: string;
  messageText: string;
}

export const EMPTY_STATE_CONFIG: Record<
  EmptyStatePage,
  (language: Language) => EmptyStateConfig
> = {
  payables: (language) => ({
    boxTitle: leng[language].payables,
    image: missingPayablesImage,
    messageTitle: leng[language].missingDataPayablesTitle,
    messageText: leng[language].missingDataPayablesText,
  }),
  receivables: (language) => ({
    boxTitle: leng[language].receivables,
    image: missingReceivablesImage,
    messageTitle: leng[language].missingDataReceivablesTitle,
    messageText: leng[language].missingDataReceivablesText,
  }),
  clients: (language) => ({
    boxTitle: leng[language].clients,
    image: missingClientsImage,
    messageTitle: leng[language].missingDataClientsTitle,
    messageText: leng[language].missingDataClientsText,
  }),
};
